import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { isNullOrUndefined } from 'src/app/services/utils';
import { COMMON_CONSTANTS } from '../common/core/common.constants';

export class ServiceMessage {
  public show: boolean;
  public message: {
    errorKey: any,
    errorMessage: any,
    errorType: any,
  };
}

// tslint:disable-next-line:max-classes-per-file
@Injectable({
  providedIn: 'root',
})
export class ErrorMessageService {

  private dataSource = new BehaviorSubject<ServiceMessage>({ message: null, show: false });
  serviceData = this.dataSource.asObservable();
  itemArray: any = [];
  errorAlert: ServiceMessage = { message: null, show: false };
  errorCodesJSON: any;
  genericErrorMessage: any;
  serverErrorMessage: ServiceMessage = { message: null, show: false };
  errorCodesJSONText: any;
  errorKey: any;
  subscription: Subscription;
  constructor() {
    //tslint:disable:no-empty
    //@ts-ignore
  }

  serviceError(errorRes: any, showError: boolean) {
    const error: ServiceMessage = {
      message: {
        errorKey: errorRes.errorCode,
        errorMessage: errorRes.errorMessage,
        errorType: errorRes.errorType
      },
      show: showError
    };
    this.constructErrorMessage(error);
  }

  constructErrorMessage(response: any) {

    if ((response.message) && (response.show === true)) {

      this.errorKey = response.message.errorKey;
      this.genericErrorMessage = response.message.errorMessage;

      if (this.errorKey || this.genericErrorMessage) {

        this.errorCodesJSON = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.CONTENT));

        if (this.errorCodesJSON) {

          this.errorCodesJSONText = this.errorCodesJSON.errorconfigs;

          if (!isNullOrUndefined(this.errorCodesJSONText)) {
            for (const errorCode of this.errorCodesJSONText) {
              const element = errorCode;
              this.itemArray.push(element);
            }
          }

          this.itemArray.forEach((element) => {
            if (this.errorKey === element.errorkey) {
              this.serverErrorMessage = element.errorvalue;
            }
          });
        }

        if (this.errorKey || this.genericErrorMessage) {
          if (this.serverErrorMessage && this.serverErrorMessage.message != null) {

            this.errorAlert = {
              message: {
                errorKey: response.message.errorKey,
                errorMessage: this.serverErrorMessage,
                errorType: response.message.errorType
              }, show: response.show
            };

          } else if (this.genericErrorMessage) {

            this.errorAlert = {
              message: {
                errorKey: response.message.errorKey,
                errorMessage: this.genericErrorMessage,
                errorType: response.message.errorType
              }, show: response.show
            };

          } else {
            this.errorAlert = { message: this.errorKey, show: response.show };
          }
        }
      }
    }
  }

  getErrorMessage(): ServiceMessage {
    return this.errorAlert;
  }

  sendErrorMessgae(genricMessage: any) {
    this.dataSource.next(genricMessage);
  }

  getServerErrorMessage() {
    return this.serverErrorMessage;
  }

  serverErrorMessgae(errorMessage: any, showError: boolean) {
    this.serverErrorMessage = {
      message: {
        errorKey: errorMessage.errorCode,
        errorMessage: errorMessage.errorMessage,
        errorType: errorMessage.errorType
      },
      show: showError
    };
  }
}
